






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { User } from "@/classes/User";
import { GameStore } from "@/stores/GameStore";
import { GlobalStore } from "@/stores/GlobalStore";
import * as DragEventHandler from "@/functions/DragEventListeners";
import { EMPTY_SEAT } from "@/Constants";
import { IdFactory } from "@/classes/IdFactory";

@Component
export default class PlayerArea extends Vue {
  @Prop(Number) readonly index!: number;
  @Prop(GameStore) readonly gameStore!: GameStore;
  @Prop(GlobalStore) readonly globalStore!: GlobalStore;

  private readonly defaultText1: string = "Empty Seat.";
  private readonly defaultText2: string = "Click to Sit.";

  get seatData() {
    return this.gameStore.seats[this.index];
  }

  get owner() {
    return this.seatData.owner;
  }

  get isFree() {
    return this.seatData.isFree();
  }

  get ownerName() {
    return this.owner != EMPTY_SEAT ? (this.owner as User).getUsername() : "";
  }

  get id() {
    return IdFactory.getPlayerAreaId(this.index);
  }

  dragLeave(e: DragEvent) {
    DragEventHandler.dragLeave(e);
  }

  dragEnter(e: DragEvent) {
    DragEventHandler.dragEnter(e);
  }

  dragDrop(e: DragEvent) {
    DragEventHandler.cardDrop(e, this.gameStore, this.owner);
  }

  sitDown() {
    if (this.globalStore.user) {
      this.gameStore.takeSeat(this.index, this.globalStore.user as User);
      document.addEventListener("beforeunload", () => {
        this.gameStore.freeSeat(this.index);
      });
    }
  }
}
